import { render, staticRenderFns } from "./ps_update_password_form.vue?vue&type=template&id=ceefa882&"
import script from "./ps_update_password_form.vue?vue&type=script&lang=js&"
export * from "./ps_update_password_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports